<template>
  <div class="industryAnalysis-page">
    <el-tabs v-model="goodsTypeTab" @tab-click="goodsTypeTabHandleClick">
      <el-tab-pane label="当期网络零售额" name="currentSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-col :span="3">
              <el-select v-model="value" placeholder="请选择"  size="small" @change="getWholeList" class="margin-l-20">
                <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-form-item label="时间：" style="margin-left: 200px">
              <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" :picker-options="pickerOptions"
                              size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM"
                              value-format="yyyy-MM" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="oneTierOptions" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="oneTierTable" stripe height="400" class="float-left border-DEDEDE margin-t-30"
                        :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
<!--                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>-->
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="twoTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="twoTierTable" height="400" stripe class="float-left border-DEDEDE colorChang"
                        :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="threeTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="threeTierTable" height="400" stripe class="float-left border-DEDEDE colorChang" :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1.按照国家统计局《批发和零售业统计报表制度》及商务部《网络零售监测指标规范：商品及服务分类及代码》，将实物商品划分为粮油和食品类、饮料类、烟酒类、服装和鞋帽及针纺织品类、化妆品类、金银珠宝类、日用品类、体育和娱乐用品类、书报杂志类、电子出版物及音像制品类、家用电器及音像器材类、中西药品类、文化办公用品类、家具类、通讯器材类、建筑及装潢材料类、汽车类、五金和电料类、煤炭及制品类、木材及制品类、石油及制品类、化工材料及制品类、金属材料类、机电产品及设备类、种子饲料类、棉麻类、其他类，共27个大类，具体细分为104个二级类目690个三级类目。
        </p>
      </el-tab-pane>
      <el-tab-pane label="累计网络零售额" name="cumulativeSales">
        <el-card class="margin-l-30 text-left margin-r-30">
          <el-form ref="form" :model="currentSalesForm" label-width="92px">
            <el-col :span="3">
              <el-select v-model="value" placeholder="请选择"  size="small" @change="getWholeList" class="margin-l-20">
                <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>
              </el-select>
            </el-col>
            <el-form-item label="时间：" style="margin-left: 200px">
              <el-date-picker v-model="currentSalesForm.endTime" placeholder="选择日期" type="month" :picker-options="pickerOptions"
                              size="small" @change="getWholeList(wholeTime = 2)" format="yyyy-MM"
                              value-format="yyyy-MM" :clearable="false"></el-date-picker>
            </el-form-item>
          </el-form>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="oneTierOptions" autoresize class="width-z100 margin-t-30"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="oneTierTable" stripe height="400" class="float-left border-DEDEDE margin-t-30"
                        :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业" align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
<!--                <el-table-column prop="absoulte_value_yoy" label="同比（%）" align="center"></el-table-column>-->
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="twoTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="twoTierTable" height="400" stripe class="float-left border-DEDEDE colorChang"
                        :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业"  align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <el-row>
            <el-col :span="13">
              <chart ref="chart1" :options="threeTierOptions" autoresize class="width-z100"></chart>
            </el-col>
            <el-col :span="10" class="margin-l-30">
              <el-table :data="threeTierTable" height="400" stripe class="float-left border-DEDEDE colorChang" :default-sort="{prop: 'absoulte_value', order: 'descending'}">
                <el-table-column type="index" label="排名" width="80" align="center"></el-table-column>
                <el-table-column prop="absoulte_key" label="行业"  align="center"></el-table-column>
                <el-table-column prop="absoulte_value" label="网络零售额（万元）" align="center"></el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>
        <p class="margin-l-30 margin-r-20 font-14 text-8A8A8A">
          注：<br/>
          1.按照国家统计局《批发和零售业统计报表制度》及商务部《网络零售监测指标规范：商品及服务分类及代码》，将实物商品划分为粮油和食品类、饮料类、烟酒类、服装和鞋帽及针纺织品类、化妆品类、金银珠宝类、日用品类、体育和娱乐用品类、书报杂志类、电子出版物及音像制品类、家用电器及音像器材类、中西药品类、文化办公用品类、家具类、通讯器材类、建筑及装潢材料类、汽车类、五金和电料类、煤炭及制品类、木材及制品类、石油及制品类、化工材料及制品类、金属材料类、机电产品及设备类、种子饲料类、棉麻类、其他类，共27个大类，具体细分为104个二级类目690个三级类目。
        </p>
      </el-tab-pane>
      <el-tab-pane label="特色行业分析" name="featuredIndustry">
<!--        <el-card class="margin-l-30 text-left margin-r-30 padding-b-25">-->
<!--            <el-col :span="3">-->
<!--              <el-select v-model="value" placeholder="请选择"  size="small" @change="getIndustryList()" class="margin-l-20">-->
<!--                <el-option v-for = 'item in typeList'  :key="item.value" :label="item.value" :value="item.value"></el-option>-->
<!--              </el-select>-->
<!--            </el-col>-->
<!--        </el-card>-->
        <el-card class="margin-t-30 margin-l-30 text-left margin-r-30 margin-b-40">
          <chart ref="chart1" :options="featuredIndustryOptions" autoresize class="width-z100 margin-t-30"></chart>
        </el-card>
      </el-tab-pane>

    </el-tabs>
  </div>
</template>

<script>
  export default {
    name: 'industryAnalysis',
    data () {
      return {
        goodsTypeTab: 'currentSales',
        chooseType: '当期网络零售额',//当前选择查询条件
        value:"九江市",
        typeList:[{'value':'九江市'},{'value':'柴桑区'},{'value':'德安县'},{'value':'都昌县'},{'value':'共青城市'},
          {'value':'湖口县'},{'value':'濂溪区'},{'value':'庐山市'},{'value':'彭泽县'},{'value':'瑞昌市'},{'value':'武宁县'},
          {'value':'修水县'},{'value':'浔阳区'},{'value':'永修县'}],
        oneTierOptions: {}, //一级行业网络零售额图表
        twoTierOptions: {}, //二级行业网络零售额图表
        threeTierOptions: {}, //三级行业网络零售额图表
        oneTierTable: [],//一级行业表格
        twoTierTable: [],//二级行业表格
        threeTierTable: [],//三级行业表格
        currentSalesForm: {startTime: '', endTime: ''},//当期网络零售额筛选条件
        wholeTime: '1',
        cumulativeSalesOptions: {},//累计网络零售额图表
        currentRetailOptions: {},//当期网络零售量图表
        cumulativeRetailOptions: {},//累计网络零售量图表
        peopleEngagedNumOptions: {},//从业人数图表
        ExpressDeliveryVolumeOptions: {},//快递量图表

        cityChoose: [{
          id: 1,
          name: '南昌市',
          children: [{id: 1, name: '青山湖区'}, {id: 2, name: '东湖区'}, {id: 3, name: '西湖区'}, {id: 4, name: '南昌县'}, {
            id: 5,
            name: '青云谱区'
          }, {id: 6, name: '新建区'}, {id: 7, name: '进贤县'}, {id: 8, name: '湾里区'}, {id: 9, name: '安义县'}]
        },
          {id: 2, name: '九江'}, {id: 3, name: '景德镇'}, {id: 4, name: '上饶'},
          {id: 5, name: '鹰潭', children: [{id: 1, name: '贵溪市'}]}, {id: 6, name: '宜春'}, {id: 7, name: '萍乡'}, {
            id: 8,
            name: '新余'
          }, {id: 9, name: '抚州'}, {id: 10, name: '吉安'}, {id: 11, name: '赣州'}],
        productTime: '1',
        productForm: {way: '1', endTime: ''}, //商品大类筛选条件
        transactionTime: '1',
        transactionTitle: '',
        transactionForm: {way: '1', resource: '1', startTime: '', endTime: '', platform: '全部'},//交易平台筛选条件
        regionDis: true,
        //表格数据

        productTwoTable: [],
        forecastOptions:{},//行业预测
        featuredIndustryOptions:{},//特色行业
        pickerOptions: {
          disabledDate: (time) => {
            // console.log(time.getMonth());
            let nowDate = new Date()
            let day = nowDate.getDate()
            nowDate.setDate(1);
            if (day > 14) {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-1);
              }
            } else {
              if(nowDate.getMonth()==0){
                nowDate.setMonth(10);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else if(nowDate.getMonth()==1){
                nowDate.setMonth(11);
                nowDate.setFullYear(nowDate.getFullYear()-1);
              }
              else{
                nowDate.setMonth(nowDate.getMonth()-2);
              }
            }
            if(time.getFullYear()<2020){
              nowDate.setFullYear(time.getFullYear()-1)
              // console.dir(nowDate)
            }return time > nowDate
          }
        },
      }
    },
    mounted () {

    },
    created () {
      this.$emit('public_header', true)
      this.oneMonth()
      // this.oneMonth()
    },
    methods: {
      dateChangebirthday (val) {
        this.wholeTime = 2
        this.currentSalesForm.value1 = val
      },
      goodsTypeTabHandleClick (tab, event) {
        if (tab.name == 'cumulativeSales') {
          this.chooseType = '累计网络零售额'
          this.getWholeList()
        }
        if (tab.name == 'currentSales') {
          this.chooseType = '当期网络零售额'
          this.getWholeList()
        }
        if (tab.name == 'featuredIndustry') {
          this.getIndustryList()
        }

      },
      //行业列表
      getWholeList () {
        this.$http.get(this.header + '/qyjc/goodsIndustry', {
          params: {
            index_type: this.chooseType,
            times: this.currentSalesForm.endTime,
            city: this.value,
          }
        }).then(res => {
          if (res.data.code == 0) {

            let wholeList = {xName: [], yTotalMoney: []}
            //一级行业图表
            res.data.oneTier.forEach((y, index) => {
              wholeList.xName.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              wholeList.yTotalMoney.push(yMoney)
            })
            this.oneTierTable = res.data.oneTier.reverse()
            let Min1 = this.calMin(wholeList.yTotalMoney), Max1 = this.calMax(wholeList.yTotalMoney)
            //一级行业图表

            this.oneTierOptions = {
              title: {//图表标题
                text: this.value + '实物一级行业'+this.chooseType,
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 10000
                },
              },
              grid: {
                left: '6%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 万元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '万元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                min: 0,
                max: Max1,
                splitNumber: 5,
                interval: (Max1 - 0) / 5,
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: wholeList.xName
              },
              dataZoom: [{
                type: 'slider',//图表下方的伸缩条
                yAxisIndex: [0],
                left: 'left',
                show: true, //是否显示
                realtime: true, //拖动时，是否实时更新系列的视图
                start: 50, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
              }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      var colorList = ['#4c83d2']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 1]
                    }
                  },
                  emphasis: {
                    color: '#7ba9eb'
                  }
                },
                data: wholeList.yTotalMoney,
              }]
            }
            //二级行业图表
            let twoTierList = {xName: [], yTotalMoney: []}
            res.data.twoTier.forEach((y, index) => {
              twoTierList.xName.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              twoTierList.yTotalMoney.push(yMoney)
            })
            this.twoTierTable = res.data.twoTier.reverse()
            let twoTierMax1 = this.calMax(twoTierList.yTotalMoney)
            this.twoTierOptions = {
              title: {//图表标题
                text: this.value + '实物二级类目'+this.chooseType,
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              grid: {
                left: '6%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 万元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '万元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                min: 0,
                max: twoTierMax1,
                splitNumber: 5,
                interval: (twoTierMax1 - 0) / 5,
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: twoTierList.xName
              },
              dataZoom: [{
                type: 'slider',//图表下方的伸缩条
                yAxisIndex: [0],
                left: 'left',
                show: true, //是否显示
                realtime: true, //拖动时，是否实时更新系列的视图
                start: 50, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
              }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      var colorList = ['#8a98e8']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 1]
                    }
                  },
                  emphasis: {
                    color: '#aab7ff'
                  }
                },
                data: twoTierList.yTotalMoney,
              }]
            }
            //三级行业图表
            let threeTierList = {xName: [], yTotalMoney: []}
            res.data.threeTier.forEach((y, index) => {
              threeTierList.xName.push(y.absoulte_key)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              threeTierList.yTotalMoney.push(yMoney)
            })
            this.threeTierTable = res.data.threeTier.reverse()
            let threeTierMax1 = this.calMax(threeTierList.yTotalMoney)
            this.threeTierOptions = {
              title: {//图表标题
                text: this.value + '实物三级类目'+this.chooseType,
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              grid: {
                left: '6%',
                // right: '4%',
                bottom: '3%',
                containLabel: true
              },
              tooltip: { // 鼠标悬浮
                backgroundColor: 'rgba(50,50,50,0.7)',
                trigger: 'item',
                formatter: '{b}网络零售额<br/>{c} 万元'
              },
              toolbox: { //图表工具箱
                feature: {
                  // dataView: {show: true, readOnly: false},
                  magicType: {show: true, type: ['line', 'bar']},
                  // restore: {show: true},
                  saveAsImage: {show: true}
                }
              },
              xAxis: {
                type: 'value',
                name: '万元',
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                min: 0,
                max: threeTierMax1,
                splitNumber: 5,
                interval: (threeTierMax1 - 0) / 5,
              },
              yAxis: {
                type: 'category',
                // axisLabel: {'interval': 0, rotate: 40},
                axisLine: {
                  lineStyle: {
                    color: '#666'
                  }
                },
                data: threeTierList.xName
              },
              dataZoom: [{
                type: 'slider',//图表下方的伸缩条
                yAxisIndex: [0],
                left: 'left',
                show: true, //是否显示
                realtime: true, //拖动时，是否实时更新系列的视图
                start: 50, //伸缩条开始位置（1-100），可以随时更改
                end: 100, //伸缩条结束位置（1-100），可以随时更改
              }],
              series: [{
                name: '月份',
                type: 'bar',
                barCategoryGap: '60%',
                itemStyle: {
                  normal: {
                    color: function (params) {
                      var colorList = ['#68b0dc']
                      //  var colorList = ['red','blue'];
                      return colorList[params.dataIndex % 1]
                    }
                  },
                  emphasis: {
                    color: '#96d7ff'
                  }
                },
                data: threeTierList.yTotalMoney,
              }]
            }
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //特色行业
      getIndustryList(){
        this.$http.get(this.header + '/trend/list',{
          params: {
            city: this.value,
          }
        }).then(res => {
          if (res.data.code == 0) {
            let industryName = []
            //粮油、食品
            let foodList = {xName: [], yTotalMoney: [],industry:'',yForecast: []}
            industryName.push(res.data.list41[0].absoulte_key)
            res.data.list41.forEach((y, index) => {
              foodList.industry = y.absoulte_key
              foodList.xName.push(y.times)
              if(y.index_type=="预测值") {
                foodList.yForecast.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'预测值'
                })
              } else if(y.index_type=="实际值"){
                foodList.yTotalMoney.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'实际值'
                })
                foodList.yForecast.push({
                  value: null,
                  unit: '万元',
                  type:'预测值'
                })
              }
            })
            //文化办公用品
            let officeList = {xName: [], yTotalMoney: [],industry:'', yForecast: []}
            industryName.push(res.data.list21[0].absoulte_key)
            res.data.list21.forEach((y, index) => {
              officeList.industry = y.absoulte_key
              officeList.xName.push(y.times);
              if(y.index_type=="预测值") {
                officeList.yForecast.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'预测值'
                })
              } else if(y.index_type=="实际值"){
                officeList.yTotalMoney.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'实际值'
                })
                officeList.yForecast.push({
                  value: null,
                  unit: '万元',
                  type:'预测值'
                })
              }
            })
            //日用品
            let dailyList = {xName: [], yTotalMoney: [],industry:'', yForecast: []}
            industryName.push(res.data.list31[0].absoulte_key)
            res.data.list31.forEach((y, index) => {
              dailyList.industry = y.absoulte_key
              dailyList.xName.push(y.times)
              if(y.index_type=="预测值") {
                dailyList.yForecast.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'预测值'
                })
              } else if(y.index_type=="实际值"){
                dailyList.yTotalMoney.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'实际值'
                })
                dailyList.yForecast.push({
                  value: null,
                  unit: '万元',
                  type:'预测值'
                })
              }
            })
            //服装鞋帽、针纺织品
            let shoesList = {xName: [], yTotalMoney: [],industry:'', yForecast: []}
            industryName.push(res.data.list01[0].absoulte_key)
            res.data.list01.forEach((y, index) => {
              shoesList.industry = y.absoulte_key
              shoesList.xName.push(y.times)
              if(y.index_type=="预测值") {
                shoesList.yForecast.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'预测值'
                })
              } else if(y.index_type=="实际值"){
                shoesList.yTotalMoney.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'实际值'
                })
                shoesList.yForecast.push({
                  value: null,
                  unit: '万元',
                  type:'预测值'
                })
              }
            })
            //化妆品
            let cosmeticsList = {xName: [], yTotalMoney: [],industry:'', yForecast: []}
            industryName.push(res.data.list11[0].absoulte_key)
            res.data.list11.forEach((y, index) => {
              cosmeticsList.industry = y.absoulte_key
              cosmeticsList.xName.push(y.times)
              if(y.index_type=="预测值") {
                cosmeticsList.yForecast.push({
                  value: y.absoulte_value,
                  unit: '万元',
                  type:'预测值'
                })
              } else if(y.index_type=="实际值"){
                cosmeticsList.yTotalMoney.push({
                    value: y.absoulte_value,
                      unit: '万元',
                      type:'实际值'
                  })
                cosmeticsList.yForecast.push({
                  value: null,
                  unit: '万元',
                  type:'预测值'
                })
              }
            })
            //特色行业
            this.featuredIndustryOptions = {
              color: ['#c23531', '#2f4554','#61a0a8','#d48465','#a4d0bc'],
              title: {
                text: '九江市特色行业分析',
                left: 'left',
                textStyle: {
                  color: '#313131',
                  fontSize: 18,
                  fontWeight: 300,
                  marginBottom: 1000
                },
              },
              tooltip: {
                trigger: 'axis',
                axisPointer:{
                  type:'cross'
                },
                formatter: function(data, value) {
                  let str = '',
                    type = "";
                  data.map(item => {
                    if(item.value != null) {
                      str += `${item.seriesName}：${item.value}万元<br/>`;
                      type = item.data.type
                    }
                  })
                  return type + '<br />' +str
                }

              },
              legend: {
                data: industryName
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: cosmeticsList.xName
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: officeList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: officeList.yTotalMoney
                },
                {
                  name: cosmeticsList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: cosmeticsList.yTotalMoney
                },
                {
                  name: foodList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: foodList.yTotalMoney
                },
                {
                  name: dailyList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: dailyList.yTotalMoney
                },
                {
                  name: shoesList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  data: shoesList.yTotalMoney
                },
                {
                  name: officeList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  lineStyle: {
                    type: 'dashed'
                  },
                  data: officeList.yForecast
                },
                {
                  name: cosmeticsList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  lineStyle: {
                    type: 'dashed'
                  },
                  data: cosmeticsList.yForecast
                },
                {
                  name: foodList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  lineStyle: {
                    type: 'dashed'
                  },
                  data: foodList.yForecast
                },
                {
                  name: dailyList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  lineStyle: {
                    type: 'dashed'
                  },
                  data: dailyList.yForecast,
                },
                {
                  name: shoesList.industry,
                  type: 'line',
                  stack: '总量',
                  areaStyle: {},
                  lineStyle: {
                    type: 'dashed'
                  },
                  data: shoesList.yForecast
                }

              ]
            };
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //行业预测
      getForecastList () {
        this.$http.get(this.header + '/trend/list').then(res => {
          if (res.data.code == 0) {
            let industryName = []
            //粮油、食品
            let foodList = {xName: [], yTotalMoney: [],industry:''}
            industryName.push(res.data.list41[0].absoulte_key)
            res.data.list41.forEach((y, index) => {
              foodList.industry = y.absoulte_key
              foodList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              foodList.yTotalMoney.push(yMoney)
            })
            //文化办公用品
            let officeList = {xName: [], yTotalMoney: [],industry:''}
            industryName.push(res.data.list21[0].absoulte_key)
            res.data.list21.forEach((y, index) => {
              officeList.industry = y.absoulte_key
              officeList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              officeList.yTotalMoney.push(yMoney)
            })
            //日用品
            let dailyList = {xName: [], yTotalMoney: [],industry:''}
            industryName.push(res.data.list31[0].absoulte_key)
            res.data.list31.forEach((y, index) => {
              dailyList.industry = y.absoulte_key
              dailyList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              dailyList.yTotalMoney.push(yMoney)
            })
            //服装鞋帽、针纺织品
            let shoesList = {xName: [], yTotalMoney: [],industry:''}
            industryName.push(res.data.list01[0].absoulte_key)
            res.data.list01.forEach((y, index) => {
              shoesList.industry = y.absoulte_key
              shoesList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              shoesList.yTotalMoney.push(yMoney)
            })
            //化妆品
            let cosmeticsList = {xName: [], yTotalMoney: [],industry:''}
            industryName.push(res.data.list11[0].absoulte_key)
            res.data.list11.forEach((y, index) => {
              cosmeticsList.industry = y.absoulte_key
              cosmeticsList.xName.push(y.times)
              let yMoney = {
                value: y.absoulte_value,
                unit: '万元'
              }
              cosmeticsList.yTotalMoney.push(yMoney)
            })

            //行业预测
            this.forecastOptions = {
              title: {
                text: this.value +  '行业预测'
              },
              tooltip: {
                trigger: 'axis'

              },
              legend: {
                data: industryName
              },
              grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'category',
                boundaryGap: false,
                data: cosmeticsList.xName
              },
              yAxis: {
                type: 'value'
              },
              series: [
                {
                  name: cosmeticsList.industry,
                  type: 'line',
                  stack: '总量',
                  data: cosmeticsList.yTotalMoney
                },
                {
                  name: dailyList.industry,
                  type: 'line',
                  stack: '总量',
                  data: dailyList.yTotalMoney
                },
                {
                  name: shoesList.industry,
                  type: 'line',
                  stack: '总量',
                  data: shoesList.yTotalMoney
                },
                {
                  name: foodList.industry,
                  type: 'line',
                  stack: '总量',
                  data: foodList.yTotalMoney
                },
                {
                  name: officeList.industry,
                  type: 'line',
                  stack: '总量',
                  data: officeList.yTotalMoney
                }
              ]
            };
          } else {
            this.$alert(res.data.msg)
          }

        })
      },
      //选择近1个月
      oneMonth (val) {
        let dataArr = []
        let data = new Date()
        let day = data.getDate()
        data.setMonth(data.getMonth() + 1, 1)//获取到当前月份,设置月份
        for (var i = 0; i < 3; i++) {
          data.setMonth(data.getMonth() - 1)//每次循环一次 月份值减1
          var m = data.getMonth() + 1
          m = m < 10 ? '0' + m : m
          dataArr.push(data.getFullYear() + '-' + (m))
        }
        if (day > 14) {
          this.currentSalesForm.endTime = dataArr[1]
        } else {
          this.currentSalesForm.endTime = dataArr[2]
        }
        this.wholeTime = '1'
        this.getWholeList()

      },
      //计算最大值
      calMax (arr) {
        let max = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (max < el1.value) {
              max = el1.value
            }
          }
          // })
        })
        let maxInt = Math.ceil(max / 9.5)//不让最高的值超过最上面的刻度
        let maxVal = maxInt * 10//让显示的刻度是整数
        return maxVal
      },

      //计算最小值
      calMin (arr) {
        let min = 0
        // arr.forEach((el) => {
        arr.forEach((el1) => {
          if (!(el1 === undefined || el1 === '')) {
            if (min > el1.value) {
              min = el1.value
            }
          }
        })
        // })
        let minInt = Math.floor(min / 10)
        let minVal = minInt * 10//让显示的刻度是整数
        return minVal
      },
    }
  }
</script>

<style>

  .industryAnalysis-page {}

  .industryAnalysis-page .el-tabs__item {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold;
    font-weight: bold;
    width: 180px;
    height: 45px;
    padding: 0px;
    /*color: #CED4DF;*/
  }

  .industryAnalysis-page .el-tabs__active-bar {
    background-color: transparent;
  }

  .industryAnalysis-page .el-tabs__header {
    margin-left: 30px;
    margin-right: 30px;
    margin-bottom: 0px;
  }

  .industryAnalysis-page .el-tabs__item.is-active {
    background-color: #3865A5;
    color: white;
  }

  .industryAnalysis-page .el-form-item {
    margin-bottom: 0;
  }

  .industryAnalysis-page .el-radio, .industryAnalysis-page .el-form-item__label {
    color: #666;
  }
  .industryAnalysis-page .el-select .el-input__inner{
    width: 170px;
    height: 32px;
    color: #6B7991 !important;
    margin-top: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/area/industryAnalysis.vue